type Stat = {
  label: string
  value: string | number
  sublabel?: string
}

type Props = {
  stats: Stat[]
}

export default function AdminStatsRow({ stats }: Props) {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 xl:grid-cols-5 mb-5'>
      {stats.map((stat, idx) => (
        <div key={idx} className='rounded-2xl bg-white border border-gray-100 shadow-sm p-4'>
          <p className='text-xs sm:text-sm font-medium text-gray-500'>{stat.label}</p>
          <p className='text-2xl sm:text-3xl font-bold text-gray-900 mt-1 break-words'>{stat.value}</p>
          {stat.sublabel && <p className='text-xs sm:text-sm text-gray-500'>{stat.sublabel}</p>}
        </div>
      ))}
    </div>
  )
}
